import React, { FC } from 'react'
import { RouteComponentProps, Switch } from 'react-router-dom'
import { t } from '@lingui/macro'

import { UpcomingEventsPage } from './events-list-page/UpcomingEventsPage'
import {
  EventsTagPageAsAdmin,
  EventsTagPageAsStudent
} from './events-tag-page/EventsTagPage'
import { Page } from '../../components/common/page/Page'
import HeadTitle from '../../components/common/head/HeadTitle'
import PrivateRoute from '../../components/private-route/PrivateRoute'
import { OrganisationRoleEnum } from 'types/Organisation'

import './EventsPage.less'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

export const EventsPage: FC<RouteComponentProps> = ({ match: { url } }) => {
  const { session } = usePublicApiSession()

  const isStudent =
    session?.user.organisation_role === OrganisationRoleEnum.STUDENT

  return (
    <Page className="EventsPage">
      <HeadTitle title={t`Upcoming events`} />
      <Switch>
        <PrivateRoute
          id="EventsPage"
          path={`${url}/tag/:tagId`}
          render={(props) => {
            const getTagId = () => {
              const {
                match: {
                  params: { tagId }
                }
              } = props
              return Number(tagId)
            }

            return isStudent ? (
              <EventsTagPageAsStudent tagId={getTagId()} />
            ) : (
              <EventsTagPageAsAdmin tagId={getTagId()} />
            )
          }}
        />
        <PrivateRoute exact path={`${url}/`} component={UpcomingEventsPage} />
      </Switch>
    </Page>
  )
}
